import { getApv, postApv } from '../../apis';
import { SDK_DOMAIN } from '../../constants';
import {
  cardNumberForm,
  closeBottomSheet,
  decodeJWT,
  deserialize,
  getIframe,
  getMethodModalLayer,
  getMethodRegiModalLayer,
  serialize,
  setAddEventListener,
  setBottomSheet,
  setIframeInnerHtml,
  showBottomSheet,
  stringToHTML,
} from '../../helpers';
import { pushRouter, routes } from '../../router';
import { setDisableBackControl } from '../../utils/back-control';
import { amtFormatter, isEmpty } from '../../utils/common';
import { setAlertModal, showAlertModal } from '../components/alert';

const OnlinePay = {
  render: async () => {
    const state = history.state;

    return `
    <div>
      <a id="connect_pay_back_button" class="c_back"></a>
      </div>
      <div class="m_t_60 m_b_20 text_center">
        <div class="c_label4_4">${state.repItemName}</div>
        <div class="c_label2_2" id="tr_amt_big">0원</div>
      </div>
      <div class="form-group m_b_20">
        <label class="c_label1">결제상세</label>
        <div class="c_box c_bod3" id="sec_item_amt">
          <label class="c_label4_5">결제요청금액</label>
          <span class="c_label5_2" id="item_amt">${amtFormatter(
            state.itemAmt
          )}원</span>
        </div>
        <div class="c_box c_bod3" id="sec_con_dc_amt">
          <label class="c_label4_5">커넥트페이 할인</label>
          <span class="c_label5_2" id="con_dc_amt">- 0원</span>
        </div>
        <div class="c_box c_bod3" id="sec_mer_dc_amt">
          <label class="c_label4_5">가맹점 할인</label>
          <span class="c_label5_2" id="mer_dc_amt">- 0원</span>
        </div>
        <div class="c_box c_bod3" id="sec_tr_amt">
          <label class="c_label4_5">실 승인금액</label>
          <span class="c_label5_2" id="tr_amt">0원</span>
        </div>
      </div>
      <div class="form-group m_b_20">
        <label class="c_label1">결제수단</label>
        <div class="c_bod1 c_box skin1_bod" id="payment_method">
          <input type="hidden" id="method_info" name="method_info" />
          <div id="method_nm" class="c_label4_3"></div>
          <a href="javascript:void(0)" class="c_more1"><img src="${SDK_DOMAIN}/images/icon_more.svg" /></a>
        </div>
      </div>
      <div id="cash_receipt_div" class="form-group m_b_20">
        <label class="c_label1">현금영수증</label>
        <input type="text" id="cash_iss_inf" class="form-control c_input1 skin1_input" placeholder="01012345678">
      </div>
      <div id="select_ist_mons" class="form-group m_b_20">
        <div class="c_box">
            <label class="c_label1">할부개월</label>
        </div>
        <div class="c_bod1 c_box skin1_bod">
            <input type="hidden" id="ist_mons" value="00" />
            <div class="c_label4_3" id="ist_mons_nm" >일시불</div>
            <a href="javascript:void(0)" class="c_more1"><img src="${SDK_DOMAIN}/images/icon_more.svg" /></a>
      </div>
      <div class="form-group m_t_20 m_b_20">
        <span class="c_label5_1">
        결제 진행에 동의하시면 확인버튼을 눌러주세요.
        </span>
      </div>
    </div>
      <div class="bottom_btn_wrapper">
        <button id="online_pay_confirm" class="btn c_btn1 skin1_btn">확인</button>
      </div>
    `;
  },
  afterRender: async () => {
    setAlertModal();

    let feeResult = {};
    const payload = decodeJWT();

    try {
      const methodModalLayer = await getMethodModalLayer();
      stringToHTML(methodModalLayer).children[0].appendAfter(
        getIframe().getElementById('layer-wrapper')
      );
      const cashInfoResult = await getApv('cash/getCashInfo');
      getIframe().getElementById('cash_iss_inf').value =
        cashInfoResult.cashIssInf;
    } catch (e) {
      showAlertModal('오류', e.resultMessage);
    }

    const methodRegiModalLayer = await getMethodRegiModalLayer();
    stringToHTML(methodRegiModalLayer).children[0].appendAfter(
      getIframe().getElementById('layer-wrapper')
    );

    const istMonsModalLayer = `
    <div class="modal c_btm1" id="select_ist_mons_content">
      <div class="modal-dialog">
          <div class="modal-content">
              <div class="modal-header">
                  <h5 class="modal-title">할부개월 선택</h5>
                  <button type="button" class="close">
                      <span aria-hidden="true">&times;</span>
                  </button>
              </div>
              <div id="select_ist_mons_list" class="modal-body">
                  <div class="item c_label6_1" id="ist_mons_00" value="00">일시불</div>
                  <div class="item c_label6_1" id="ist_mons_02" value="02">2개월</div>
                  <div class="item c_label6_1" id="ist_mons_03" value="03">3개월</div>
                  <div class="item c_label6_1" id="ist_mons_04" value="04">4개월</div>
                  <div class="item c_label6_1" id="ist_mons_05" value="05">5개월</div>
                  <div class="item c_label6_1" id="ist_mons_06" value="06">6개월</div>
                  <div class="item c_label6_1" id="ist_mons_07" value="07">7개월</div>
                  <div class="item c_label6_1" id="ist_mons_08" value="08">8개월</div>
                  <div class="item c_label6_1" id="ist_mons_09" value="09">9개월</div>
                  <div class="item c_label6_1" id="ist_mons_10" value="10">10개월</div>
                  <div class="item c_label6_1" id="ist_mons_11" value="11">11개월</div>
                  <div class="item c_label6_1" id="ist_mons_12" value="12">12개월</div>
              </div>
          </div>
      </div>
    </div>
    `;

    const handleMethodChanged = async (methodInfoStr) => {
      if (isEmpty(methodInfoStr)) return;

      localStorage.setItem('CONPAY_SELECTED_METHOD_INFO', methodInfoStr);
      const methodInfo = deserialize(methodInfoStr);
      let methodNm = '';

      switch (methodInfo.trDiv) {
        case '1001':
          localStorage.setItem('CONPAY_SELECTED_METHOD', methodInfo.cardEntyno);
          methodNm = `${methodInfo.cardCoName} ${cardNumberForm(
            methodInfo.cardBin
          )}`;
          getIframe().getElementById('sec_con_dc_amt').style.display = 'none';
          getIframe().getElementById('select_ist_mons').style.display = 'block';
          getIframe().getElementById('cash_receipt_div').style.display = 'none';
          break;
        case '2001':
          localStorage.setItem('CONPAY_SELECTED_METHOD', methodInfo.accEntyno);
          methodNm = `${methodInfo.bnkName} ${methodInfo.accno}`;
          getIframe().getElementById('sec_con_dc_amt').style.display = 'flex';
          getIframe().getElementById('select_ist_mons').style.display = 'none';
          getIframe().getElementById('cash_receipt_div').style.display =
            'block';
          break;
        default:
          localStorage.setItem('CONPAY_SELECTED_METHOD', 'money');
          methodNm = `충전머니 ${amtFormatter(methodInfo.moneyBalance)} 원`;
          getIframe().getElementById('sec_con_dc_amt').style.display = 'flex';
          getIframe().getElementById('select_ist_mons').style.display = 'none';
          getIframe().getElementById('cash_receipt_div').style.display =
            'block';
          break;
      }

      getIframe().getElementById('method_info').value = methodInfoStr;
      getIframe().getElementById('method_nm').innerHTML = methodNm;

      try {
        const state = history.state;
        // 수수료정보
        feeResult = await postApv('common/getFeeInfo', {
          bid: payload.bi,
          cid: state.cid,
          itemAmt: state.itemAmt,
          svcAmt: state.svcAmt,
          trDiv: methodInfo.trDiv.substring(0, 2), // 10 카드 20 계좌 30 충전머니
        });
        setIframeInnerHtml(
          'con_dc_amt',
          `- ${amtFormatter(feeResult.conDcAmt)}원`
        );
        setIframeInnerHtml(
          'mer_dc_amt',
          `- ${amtFormatter(feeResult.merDcAmt)}원`
        );
        setIframeInnerHtml('tr_amt', `${amtFormatter(feeResult.trAmt)}원`);
        setIframeInnerHtml('tr_amt_big', `${amtFormatter(feeResult.trAmt)}원`);

        // 카드 할부개월은 결제금액 5만원 이상만 선택 가능
        if (
          methodInfo.trDiv.substring(0, 2) == '10' &&
          feeResult.trAmt >= 50000
        ) {
          stringToHTML(istMonsModalLayer).children[0].appendAfter(
            getIframe().getElementById('layer-wrapper')
          );
          setBottomSheet('select_ist_mons');
        }
      } catch (e) {
        showAlertModal('오류', e.resultMessage);
        console.error(e);
      }

      closeBottomSheet('payment_method');
    };

    // 결제수단 초기세팅
    handleMethodChanged(localStorage.getItem('CONPAY_SELECTED_METHOD_INFO'));

    getIframe()
      .querySelectorAll('#payment_method_list > div')
      .forEach((element) => {
        element.getAttribute('id') == 'pay_method_regi'
          ? element.addEventListener('click', () =>
              closeBottomSheet('payment_method')
            )
          : element.addEventListener('click', () =>
              handleMethodChanged(element.getAttribute('value'))
            );
      });

    getIframe()
      .querySelectorAll('#pay_method_regi_list > div')
      .forEach((element) => {
        element.addEventListener('click', () => {
          closeBottomSheet('pay_method_regi');
          pushRouter(null, null, element.getAttribute('value'), () => {
            setDisableBackControl();
          });
        });
      });

    getIframe()
      .querySelectorAll('#select_ist_mons_list > div')
      .forEach((element) => {
        element.addEventListener('click', () => {
          getIframe().getElementById('ist_mons').value =
            element.getAttribute('value');
          setIframeInnerHtml('ist_mons_nm', element.innerHTML);
          closeBottomSheet('select_ist_mons');
        });
      });

    setAddEventListener('connect_pay_back_button', () => history.back());
    setAddEventListener('cash_receipt_div', () =>
      pushRouter(null, null, routes.cashReceipt.hashPath)
    );
    setAddEventListener('online_pay_confirm', async () => {
      const methodInfo = deserialize(
        localStorage.getItem('CONPAY_SELECTED_METHOD_INFO')
      );
      const trDiv = methodInfo.trDiv;
      const state = history.state;

      // 충전머니 잔액 체크
      if (trDiv == '3001' && methodInfo.moneyBalance < feeResult.trAmt) {
        showAlertModal(
          '알림',
          `충전금액이 부족합니다. 충전 후 다시 결제해주세요.`
        );
        return;
      }

      // 충전머니 결제 예약 Data
      let rsvdUrl = 'charging/rsvd/appr/paymentOk';
      let rsvdData = {
        trDiv, // 거래구분 (2001 계좌 승인 3001 충전머니 승인 ...)
        cid: state.cid, // 가맹점코드
        orderNo: state.orderNo, // 주문번호
        repItemName: state.repItemName, // 대표상품명
        itemAmt: state.itemAmt, // 상품금액
        conDcAmt: feeResult.conDcAmt, // CONNECT할인금액
        merDcAmt: feeResult.merDcAmt, // 가맹점할인금액
        realItemAmt: feeResult.realItemAmt, // 실상품금액 = itemAmt - conDcAmt - merDcAmt
        vatAmt: feeResult.vatAmt, // 부가세액 = realItemAmt * 10 / 110 정수값
        baseAmt: feeResult.baseAmt, // 공급가액 = realItemAmt - vatAmt
        svcAmt: feeResult.svcAmt, // 봉사료
        trAmt: feeResult.trAmt, // 거래금액 = realItemAmt + svcAmt
        aplyFeeAmt: feeResult.aplyFeeAmt, // 결제수수료
        merAdjAmt: feeResult.merAdjAmt, // 가맹점정산금액 = trAmt - aplyFeeAmt
      };

      // 계좌 결제 예약 Data
      if (trDiv == '2001') {
        rsvdUrl = 'account/rsvd/appr/accountPayOk';
        rsvdData = {
          ...rsvdData,
          accEntyno: methodInfo.accEntyno, // 계좌등록번호
        };
      }

      // 카드 결제 예약 Data
      if (trDiv == '1001') {
        rsvdUrl = 'card/rsvd/appr/cardPayOk';
        rsvdData = {
          ...rsvdData,
          cardEntyno: methodInfo.cardEntyno,
          istMons: getIframe().getElementById('ist_mons').value,
        };
      }

      const res = await postApv(rsvdUrl, rsvdData).catch((e) => e);

      if (!isEmpty(res.success) && !res.success) {
        showAlertModal('알림', res.resultMessage, () => history.back());
      } else {
        // 완료페이지에서 사용할 데이터
        sessionStorage.setItem('CONPAY_COMPLETE_INFO', serialize(res));

        // pin 확인 -> 완료페이지
        pushRouter(
          {
            mode: 'PIN_CHECK',
            nextHash: routes.onlinePayComplete.hashPath,
          },
          null,
          routes.enterPwd.hashPath,
          () => {
            setDisableBackControl();
          }
        );
      }
    });

    setBottomSheet('payment_method');
    setBottomSheet('pay_method_regi');

    // 등록된 결제수단(카드, 계좌) 하나도 없으면 '결제수단 추가 BottomSheet' 보여줌
    const methodListResult = await getApv('common/methodList');
    if (
      methodListResult.cardList?.length == 0 &&
      methodListResult.accountList?.length == 0
    ) {
      showBottomSheet('pay_method_regi');
    }
  },
};
export default OnlinePay;
